import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaUserPlus, FaTrash, FaArrowLeft, FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function Usuarios() {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [showModal, setShowModal] = useState(false);
    
    // Estados para Edición
    const [modalMode, setModalMode] = useState('add'); // 'add' o 'edit'
    const [editId, setEditId] = useState(null);

    const [form, setForm] = useState({ 
        nombre: '', usuario: '', password: '', rol: 'caja', sucursal_id: '' 
    });

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        try {
            const resUsers = await axios.get('https://api.alquilacarbolivia.com/api/usuarios');
            const resSucs = await axios.get('https://api.alquilacarbolivia.com/api/usuarios/sucursales');
            setUsuarios(resUsers.data);
            setSucursales(resSucs.data);
        } catch (error) { console.error(error); }
    };

    const handleEdit = (u) => {
        setModalMode('edit');
        setEditId(u.id);
        setForm({
            nombre: u.nombre,
            usuario: u.usuario,
            password: '', // Dejar vacío para no cambiar a menos que se escriba
            rol: u.rol,
            sucursal_id: u.sucursal_id || ''
        });
        setShowModal(true);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (modalMode === 'add') {
                await axios.post('https://api.alquilacarbolivia.com/api/usuarios', form);
                Swal.fire('Creado', 'Usuario registrado', 'success');
            } else {
                await axios.put(`https://api.alquilacarbolivia.com/api/usuarios/${editId}`, form);
                Swal.fire('Actualizado', 'Datos actualizados', 'success');
            }
            setShowModal(false);
            resetForm();
            fetchData();
        } catch (error) { 
            Swal.fire('Error', 'No se pudo procesar la solicitud', 'error');
        }
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: '¿Borrar usuario?',
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Sí, borrar'
        });

        if (result.isConfirmed) {
            await axios.delete(`https://api.alquilacarbolivia.com/api/usuarios/${id}`);
            fetchData();
            Swal.fire('Eliminado', '', 'success');
        }
    };

    const resetForm = () => {
        setForm({ nombre: '', usuario: '', password: '', rol: 'caja', sucursal_id: '' });
        setModalMode('add');
        setEditId(null);
    };

    return (
        <div className="container mt-4">
            <button className="btn btn-secondary mb-3 shadow-sm" onClick={() => navigate('/admin')}>
                <FaArrowLeft/> Volver
            </button>
            
            <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm">
                <h2 className="m-0 fw-bold">Gestión de Usuarios</h2>
                <button className="btn btn-primary fw-bold" onClick={() => { resetForm(); setShowModal(true); }}>
                    <FaUserPlus className="me-2"/> Nuevo Usuario
                </button>
            </div>

            <div className="card border-0 shadow-sm overflow-hidden">
                <table className="table table-hover align-middle mb-0">
                    <thead className="table-dark">
                        <tr>
                            <th className="ps-4">Nombre</th>
                            <th>Usuario</th>
                            <th>Rol</th>
                            <th>Sucursal Asignada</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuarios.map(u => (
                            <tr key={u.id}>
                                <td className="ps-4 fw-bold">{u.nombre}</td>
                                <td>{u.usuario}</td>
                                <td>
                                    <span className={`badge bg-${u.rol === 'admin' ? 'danger' : 'success'}`}>
                                        {u.rol.toUpperCase()}
                                    </span>
                                </td>
                                <td>{u.rol === 'admin' ? 'TODO EL SISTEMA' : u.sucursal || 'Sin asignar'}</td>
                                <td className="text-center">
                                    <div className="d-flex justify-content-center gap-2">
                                        <button className="btn btn-sm btn-warning" onClick={() => handleEdit(u)}>
                                            <FaEdit/>
                                        </button>
                                        {u.usuario !== 'admin' && (
                                            <button className="btn btn-sm btn-danger" onClick={() => handleDelete(u.id)}>
                                                <FaTrash/>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* MODAL CREAR / EDITAR */}
            {showModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                            <div className="modal-header border-0 pb-0">
                                <h5 className="fw-bold">{modalMode === 'add' ? 'Nuevo Usuario' : 'Editar Usuario'}</h5>
                                <button className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">Nombre Completo</label>
                                        <input className="form-control" required value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">Usuario (Login)</label>
                                        <input className="form-control" required value={form.usuario} onChange={e => setForm({ ...form, usuario: e.target.value })} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">Contraseña {modalMode === 'edit' && '(dejar vacío para no cambiar)'}</label>
                                        <input className="form-control" type="password" required={modalMode === 'add'} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">Rol</label>
                                        <select className="form-select" value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}>
                                            <option value="caja">Caja / Encargado</option>
                                            <option value="admin">Administrador</option>
                                        </select>
                                    </div>
                                    {form.rol === 'caja' && (
                                        <div className="mb-3">
                                            <label className="form-label small fw-bold">Asignar a Sucursal</label>
                                            <select className="form-select" required value={form.sucursal_id} onChange={e => setForm({ ...form, sucursal_id: e.target.value })}>
                                                <option value="">Seleccione...</option>
                                                {sucursales.map(s => (
                                                    <option key={s.id} value={s.id}>{s.nombre}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-0">
                                    <button type="button" className="btn btn-light rounded-pill" onClick={() => setShowModal(false)}>Cancelar</button>
                                    <button type="submit" className="btn btn-primary rounded-pill px-4 fw-bold">
                                        <FaSave className="me-2"/> {modalMode === 'add' ? 'Registrar' : 'Guardar Cambios'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}